// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"446":"e0554c24","564":"f91b47d2"}[chunkId] + ".chunk.css";
};